<div mat-dialog-content class="form-fields-theme">
    <form name="mobileNumberForm" [formGroup]="mobileNumberForm" (submit)="checkPhoneStatus()">
        <mat-form-field>
            <mat-label>Phone Number</mat-label>
            <input
                matInput
                data-test="phone-number-input"
                formControlName="mobile"
                type="tel"
                (keypress)="allowOnlyNumbers($event)"
                (paste)="allowOnlyNumbers($event)"
                required />
            @if (mobileNumberForm.get('mobile').hasError('pattern') || mobileNumberForm.get('mobile').hasError('required')) {
                <mat-error> Please enter a valid mobile number. </mat-error>
            }
        </mat-form-field>
        <input type="submit" style="position: absolute; left: -9999px" />
    </form>
</div>

<div class="clearfix"></div>

<div class="row">
    <div class="col-sm-12 mb-10">
        <button btn-primary size="full" id="sign-in-btn" (click)="checkPhoneStatus()" [isLoading]="continueInProgress">
            Continue
        </button>
    </div>
</div>
